import { convertToRoundedMw } from '@/features/bidding/utils/calculations/convertToRoundedMw'

export const formatVolume = (volume: number | null, unit: string) => {
  return volume != null ? `${convertToRoundedMw(volume)} ${unit}` : '-'
}
